export const categories = [
  { slug: 'zongyi', name: '综艺娱乐', icon: 'ri-tv-line', count: 286 },
  { slug: 'dianying', name: '电影资源', icon: 'ri-film-line', count: 512 },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-clapperboard-line', count: 438 },
  { slug: 'dongman', name: '动漫动画', icon: 'ri-emotion-line', count: 367 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-lens-line', count: 198 },
  { slug: 'tiyu', name: '体育赛事', icon: 'ri-run-line', count: 245 },
  { slug: 'yinyue', name: '音乐MV', icon: 'ri-music-line', count: 321 },
  { slug: 'xuexi', name: '学习教育', icon: 'ri-book-open-line', count: 156 },
];